import {useEffect, useState} from "react";
import {getAllowedRegion} from "../../service/UserService";
import {getStoredSchedulerRegions, storeSchedulerRegions} from "./RegionSelector";

const ALL_REGIONS = [];

function readResponse(response) {
    if (!response.ok) throw new Error("Unable to load regions.");
    return response.json();
}

export default function useSchedulerRegions() {
    const [allowedRegions, setAllowedRegions] = useState([]);
    const [selectedRegions, setSelectedRegions] = useState(() => getStoredSchedulerRegions() || []);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        let active = true;
        getAllowedRegion()
            .then(readResponse)
            .then((regions) => {
                if (!active) return;
                const values = Array.isArray(regions) ? regions.filter(Boolean) : [];
                const stored = getStoredSchedulerRegions();
                setAllowedRegions(values);
                setSelectedRegions(stored ? stored.filter((region) => values.includes(region)) : values);
                setErrorMessage("");
            })
            .catch((error) => {
                if (active) {
                    setSelectedRegions([]);
                    setErrorMessage(error.message || "Unable to load regions.");
                }
            });
        return () => { active = false; };
    }, []);

    function updateSelectedRegions(values) {
        const next = Array.from(new Set(values));
        setSelectedRegions(next);
        storeSchedulerRegions(next);
    }

    const filterRegions = selectedRegions.length === 0 || (allowedRegions.length > 0
        && allowedRegions.every(region => selectedRegions.includes(region))) ? ALL_REGIONS : selectedRegions;
    return {allowedRegions, errorMessage, selectedRegions, filterRegions, setSelectedRegions: updateSelectedRegions};
}
